<script>
import { mapState } from 'vuex'
import mixins from '@services/notification/notifications-mixin'

export default {
  name: 'AlertTableItem',
  mixins: [mixins],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    ...mapState({
      messages: state => state.userNotifications.userNotifications,
    }),
    itemNotifications() {
      return this.messages.filter(
        item => item.extraParameters.plugId === this.item.serial && !item.read
      )
    },
    hasNotifications() {
      return !!this.itemNotifications.length
    },
    itemText() {
      if (this.hasNotifications) {
        return this.itemNotifications[0].message
      }
    },
  },
  methods: {
    clickHandler() {
      if (this.itemNotifications[0].userId) {
        this.$store.dispatch(
          'userNotifications/markRead',
          this.itemNotifications[0].id
        )
      }
      this.doAction(this.itemNotifications[0])
    },
  },
}
</script>

<template>
  <div
    v-tooltip="itemText"
    v-if="hasNotifications"
    class="itemNotification"
    @click="clickHandler">
    <span>
      {{ itemNotifications.length }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.itemNotification {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  cursor: pointer;
  background: orangered;
  border-radius: 50%;

  span {
    font-size: 10px;
    line-height: 15px;
    color: white;
  }
}
</style>
